export default function AboutHero() {
  return (
    <section className="py-20 bg-white border-t-4 border-[#1A2B4A]">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-[#1A2B4A] mb-4">
          L'entreprise
        </p>
        <h1 className="font-poppins text-4xl lg:text-5xl font-semibold text-[#1A2B4A] mb-5">
          À Propos de SOMINKA
        </h1>
        <p className="text-gray-500 text-base leading-relaxed max-w-xl mx-auto">
          Une activité indépendante de conseil en gestion et développement d'activité, basée à Bordeaux.
        </p>
      </div>
    </section>
  );
}
